import { set_ui_settings } from 'console/redux/settings-actions';
export default class {
    store;
    readonly;
    constructor(store, readonly) {
        this.store = store;
        this.readonly = readonly;
    }
    data() {
        return this.store.getState().ui_settings;
    }
    set(setter) {
        this.store.dispatch(set_ui_settings(setter, this.readonly));
    }
}
